const handleFileUpload = (e, values, docPerKind, arrayHelpers) => {
  const docIndex = values.uploadedDocuments?.findIndex(
    (doc) => doc.doc_id === docPerKind.doc_id
  );

  if (docIndex === -1) {
    arrayHelpers.push({
      id: docPerKind?.id,
      doc_id: docPerKind?.doc_id,
      new: true,
      // Convert filelist to array
      files: [...e.target.files],
    });
  } else {
    arrayHelpers.replace(docIndex, {
      id: docPerKind?.id,
      doc_id: docPerKind?.doc_id,
      new: true,
      // Convert filelist to array
      files: [...e.target.files],
    });
  }
};

export default handleFileUpload;
